exports.baseURL = "https://allinone.codderlab.com/";
// exports.baseURL = 'http://192.168.1.16:5038/';
exports.key = 'vguikkOUno8Xcfvjhkiyb06aIKrejZ9R4h';
exports.projectName = 'Rayzi Ultimate';
